<template>
  <div class="tc-container">
    <ul>
      <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
        今日
      </li>
      <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
        近七天
      </li>
      <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
        本月
      </li>
      <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
        本年
      </li>
    </ul>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        actvIndex: 3,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = {
          backgroundColor: 'transparent',
          tooltip: {},
          grid: {
            top: '8%',
            left: '1%',
            right: '1%',
            bottom: '8%',
            containLabel: true,
          },
          legend: {
            show: false,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: true,
              axisLine: {
                //坐标轴轴线相关设置。数学上的x轴
                show: true,
                lineStyle: {
                  color: '#808487',
                },
              },
              axisLabel: {
                //坐标轴刻度标签的相关设置
                textStyle: {
                  color: '#E6E6E6',
                  margin: 15,
                },
              },
              axisTick: {
                show: false,
              },
              data: ['1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h'],
            },
          ],
          yAxis: [
            {
              type: 'value',
              min: 0,
              max: 20,
              splitNumber: 7,
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#4D5054',
                },
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                margin: 20,
                textStyle: {
                  color: '#d1e6eb',
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: '最新注册量',
              type: 'bar',
              barWidth: 10,
              tooltip: {
                show: false,
              },
              label: {
                show: false,
                position: 'top',
                textStyle: {
                  color: '#fff',
                },
              },
              itemStyle: {
                normal: {
                  barBorderRadius: 0,
                  opacity: 0.8,
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#48FFBC',
                    },
                    {
                      offset: 1,
                      color: '#2BD3DE',
                    },
                  ]),
                },
              },
              data: [12, 3, 4, 18, 6, 14, 18, 12],
            },
            {
              name: '背景',
              type: 'bar',
              barWidth: '40%',
              barGap: '-135%',
              tooltip: {
                show: false,
              },
              data: [
                100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
                100, 100,
              ],
              itemStyle: {
                normal: {
                  color: 'rgba(255,255,255,0.1)',
                },
              },
              zlevel: 9,
            },
          ],
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;
      li {
        margin-right: 30px;
        white-space: nowrap;
      }
      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 37%;
        }
      }
    }
    .tp-chart {
      margin-top: 20px;
      width: 100%;
      height: 16vh;
    }
  }
</style>
